import { render } from "./ThePhongTraoTheThao.vue?vue&type=template&id=7cb52762"
import script from "./ThePhongTraoTheThao.vue?vue&type=script&lang=js"
export * from "./ThePhongTraoTheThao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__